import request from '@/middleware/request'

const getAudio = data => {
  return request({
    url: '/audios/list',
    method: 'post',
    data
  })
}

const getAudioCategory = () => {
  return request({
    url: '/audios/category',
    method: 'get'
  })
}

const createAudio = data => {
  return request({
    url: '/audios',
    method: 'post',
    data
  })
}

const updateAudio = (category, id, data) => {
  return request({
    url: `/audios/${category}/${id}`,
    method: 'patch',
    data
  })
}

const deleteAudio = id => {
  return request({
    url: `/audios/${id}`,
    method: 'delete'
  })
}

const clearAudio = (category, id, name) => {
  return request({
    url: `/audios/clear/${category}/${id}`,
    method: 'delete',
    data: { name }
  })
}

const uploadFileAudio = formData => {
  return request({
    url: `/audios/file/upload`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

const clearFileAudio = data => {
  return request({
    url: `/audios/file/clear`,
    method: 'post',
    data
  })
}

export default {
  getAudio,
  getAudioCategory,
  createAudio,
  updateAudio,
  deleteAudio,
  clearAudio,
  uploadFileAudio,
  clearFileAudio
}
